module.exports = {"localGamesPrefix":"/static/games/","entryFile":"index.html","engines":["html5","construct2","construct3","cocos","laya","playcanvas"],"orientations":["portrait","landscape","auto"],"integrationModes":["native","adapter","legacy-compat"],"sdkProfiles":["none","poki","gdsdk","azerion","parent-gameapi","sdk-options","custom"],"healthStatuses":["draft","verified","blocked"]}


//////////////////
// WEBPACK FOOTER
// ./src/common/config/game-standards.json
// module id = QCkq
// module chunks = 1